import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getResultadosEvaluacionService, 
  getEstadisticasCompletasService 
} from "../../../../services/dashboard/resultadosEvaluacion/resultadosEvaluacion.services";

export const getResultadosEvaluacionThunk = createAsyncThunk(
  "resultadosEvaluacion/getResultados",
  async ({ page = 1, search = null } = {}, { getState, rejectWithValue }) => {
    try {
      const { escuela, plantel } = getState().dashboardFilters;
      return await getResultadosEvaluacionService({ escuela, plantel, search, page });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error obteniendo resultados de evaluación"
      );
    }
  }
);

export const getEstadisticasCompletasThunk = createAsyncThunk(
  "resultadosEvaluacion/getEstadisticas",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { escuela, plantel } = getState().dashboardFilters;
      return await getEstadisticasCompletasService({ escuela, plantel });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Error obteniendo estadísticas"
      );
    }
  }
);
